export const attribution = "Precyz.com is an initiative of Enterpryz Ventures, a Delaware corporation based in the United States.";
export function Footer() {
  return <footer className="pz-footer"><a href="https://precyz.com">Precyz</a><p>{attribution}</p></footer>;
}
